import {
  LoadingContainer,
  LegacyPage,
  Model,
  Panels,
  Bar,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams, useRouteMatch } from 'peach/router'

import { useLoanTypeDynamicFeeTypeGet } from 'core/types'

const DynamicFeeType = () => {
  const { url } = useRouteMatch()
  const { companyId, dynamicFeeTypeId, loanTypeId } = useParams<{
    companyId?: string
    dynamicFeeTypeId?: string
    loanTypeId?: string
  }>()

  const {
    data: dynamicFeeType,
    isLoading,
    error,
  } = useLoanTypeDynamicFeeTypeGet({
    dynamicFeeTypeId,
    loanTypeId,
    companyId,
  })

  const name = getName(dynamicFeeType)

  const header = <Bar title={name} />

  return (
    <Panels header={header}>
      <Breadcrumb title={name} to={url} />

      <LoadingContainer error={error} isLoading={isLoading}>
        <LegacyPage.Centered>
          <Model.Item json={dynamicFeeType} title={name} />
        </LegacyPage.Centered>
      </LoadingContainer>
    </Panels>
  )
}

export default DynamicFeeType
